import axios from 'axios';

export const createDonationCheckoutSessionService = async (payload) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/donation/create_checkout_session`, payload)
        .then((response)=>{
            return { success: true, data: response?.data, message: '' }
        }).catch((error)=>{
            console.log(error)
            return { success: false, data: null, message: error?.response?.data?.message || 'generic_server_error_message' }
        })
    } catch (error) {
        return { success: false, data: null, message: 'generic_server_error_message' }
    }
}

export const cancelDonationSubscriptionService = async (stripe_subscription_id) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/donation/cancel_subscription`, { stripe_subscription_id })
        .then((response)=>{
            return { success: true, data: response?.data, message: '' }
        }).catch((error)=>{
            console.log(error)
            return { success: false, data: null, message: error?.response?.data?.message || 'generic_server_error_message' }
        })
    } catch (error) {
        return { success: false, data: null, message: 'generic_server_error_message' }
    }
}

export const listMyDonationsService = async (user_access_key, page = 1) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/donation/list_by_user/${user_access_key}/${page}`)
        .then((response)=>{
            return { success: true, data: response?.data, message: '' }
        }).catch((error)=>{
            console.log(error)
            return { success: false, data: null, message: error?.response?.data?.message || 'generic_server_error_message' }
        })
    } catch (error) {
        return { success: false, data: null, message: 'generic_server_error_message' }
    }
}
